<div class="header-wrapper bold">
  <ng-content></ng-content>
</div>
